<template>
  <div>
    <div class="mb-3">
      <span class="mr-3">De</span>
      <lm-dropdown
        class="d-inline-block"
        key="from"
        :data-items="options"
        closeAfterPick
        hideSearchInput
        @input="onPickFrom"
      >
        <span class="text-primary">
          {{ picked.from.name }}
        </span>
      </lm-dropdown>
    </div>
    <div>
      <span class="mr-3">A</span>
      <lm-dropdown
        class="d-inline-block"
        key="to"
        :data-items="options"
        closeAfterPick
        hideSearchInput
        @input="onPickTo"
      >
        <span class="text-primary">
          {{ picked.to.name }}
        </span>
      </lm-dropdown>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import commonsApi from '@/api/commons'
import LmDropdown from '@/components/LmDropdown'

export default defineComponent({
  components: {
    LmDropdown
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    options: [
      { id: 'any', name: 'Cualquiera' }
    ],
    picked: {
      from: { id: 'any', name: 'Cualquiera' },
      to: { id: 'any', name: 'Cualquiera' }
    }
  }),
  methods: {
    onPickFrom (event) {
      this.picked.from = event
      this.$emit('change', this.picked)
    },
    onPickTo (event) {
      this.picked.to = event
      this.$emit('change', this.picked)
    }
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler (val) {
        if (val && Object.keys(val).length) {
          this.picked.from = val.from
          this.picked.to = val.to
        }
      }
    }
  },
  async created () {
    const response = await commonsApi.axiosGetWrapper('/processes/status')
    this.options = [].concat(this.options, response.data.items).map(el => {
      return { id: el.id, name: el.name }
    })
    this.$emit('change', this.picked)
  }
})
</script>
